import { css, TabList, Tab } from '@chakra-ui/react';
import { useTheme } from '../../../contexts/ThemeProvider';

export function Tabs({ tabsList, center }: { tabsList: string[]; center?: boolean }) {
  const { colors } = useTheme();

  return (
    <TabList
      overflowX="auto"
      whiteSpace="nowrap"
      justifyContent={center ? 'center' : 'flex-start'}
      alignItems={'center'}
      width={'100%'}
      gap={4}
      css={css({
        scrollbarWidth: 'none',
        '::-webkit-scrollbar': { display: 'none' },
        WebkitOverflowScrolling: 'touch',
        border: 'none',
      })}
    >
      {tabsList.map((tab, index) => (
        <Tab
          key={tab}
          fontSize={18}
          margin={'unset'}
          color={'#747474'}
          fontFamily={'Glory'}
          fontWeight="500"
          padding={0}
          marginRight={index === tabsList.length - 1 ? '20px' : 0}
          cursor="pointer"
          _selected={{
            color: '#292927',
            borderBottom: `2px solid ${colors.primaryColor} !important`,
          }}
          _hover={{
            bg: '#F5F5F5',
          }}
        >
          {tab}
        </Tab>
      ))}
    </TabList>
  );
}
